import * as fromFeature from '@app/features/company-management/store/reducers/index'

import { groupBy, sortBy } from 'lodash'
import { ApplicationSettingsState, RateCardMetaStructure, RateCardMetaStructureField } from '../models'
import { ApplicationSettingConfig, ApplicationSettingsItem } from '../models/application-settings-item.model'

import { Company } from '@app/core/model/company.model'
import { User } from '@app/core/model/user.model'
import { AuthSelectors } from '@app/core/store/selectors/auth.selector'
import { KeyValue } from '@app/core/types/key-value.type'
import { createSelector } from '@ngrx/store'
import { ApplicationSettingsConfig } from '../const/application-settings-config.const'

export const getApplicationSettingsState = createSelector(
  fromFeature.getCompanyManagementState,
  (state: fromFeature.State): ApplicationSettingsState => state.applicationSettings
)

const selectRateCardMetaStructure = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): RateCardMetaStructure => state.rateCardMetaStructure
)

const selectRateCardMetaStructureLoading = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): boolean => state.rateCardMetaStructureLoading
)

const selectRateCardMetaStructureFields = createSelector(
  selectRateCardMetaStructure,
  (state: RateCardMetaStructure): RateCardMetaStructureField[] =>
    state?.ratecardMetaStructureDefinition?.roles?.additionalFields || []
)

const selectApplicationSettings = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): ApplicationSettingsItem[] => state.settings
)

const selectMergedApplicationSettings = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): ApplicationSettingConfig[] =>
    state.settings.map((setting) => ({ ...setting, ...ApplicationSettingsConfig[setting.setting] }))
)

const selectGroupedApplicationSettings = createSelector(
  selectMergedApplicationSettings,
  AuthSelectors.selectUser,
  AuthSelectors.selectChildCompanies,
  (state: ApplicationSettingConfig[], user: User, childCompanies: Company[]): KeyValue<ApplicationSettingConfig[]> =>
    groupBy(
      sortBy(
        state.filter((setting) => (setting.isConfigurable && childCompanies ? setting.config(user) : !setting.hidden)),
        'name'
      ),
      'category'
    )
)

const selectApplicationSettingsLoading = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): boolean => state.settingsLoading
)

const selectApplicationSettingsLoadingMap = createSelector(
  getApplicationSettingsState,
  (state: ApplicationSettingsState): KeyValue<boolean> => state.settingsLoadingMap
)

export const ApplicationSettingsSelectors = {
  selectRateCardMetaStructure,
  selectRateCardMetaStructureLoading,
  selectRateCardMetaStructureFields,
  selectApplicationSettings,
  selectApplicationSettingsLoading,
  selectApplicationSettingsLoadingMap,
  selectMergedApplicationSettings,
  selectGroupedApplicationSettings,
}
